let SCREENSIZE = require('./constants').SCREENSIZE;
let desktop = window.matchMedia("(min-width: "+ SCREENSIZE.DESKTOPMIN +"px)");
let ipad = window.matchMedia("(min-width: "+ SCREENSIZE.MOBILEMAX +"px)");
let mobile = window.matchMedia("(max-width: "+ SCREENSIZE.MOBILEMAX +"px)");
let onlyIpad = window.matchMedia("(min-width: "+ SCREENSIZE.TABLETMIN +"px) and (max-width: "+ SCREENSIZE.DESKTOPMIN +"px)");
let ipadMax = window.matchMedia("(min-width: "+ SCREENSIZE.TABLETMAX +"px)");

var isDesktop = function () {
    return desktop.matches
};

var isIpad = function () {
    return ipad.matches
}

var isMobile = function () {
    return mobile.matches
}

var isOnlyIpad = function() {
    return onlyIpad.matches
}

var isIpadMax = function() {
    return ipadMax.matches
}

module.exports = {
    isDesktop: isDesktop,
    isIpad: isIpad,
    isMobile: isMobile,
    isOnlyIpad: isOnlyIpad,
    isIpadMax: isIpadMax
};